
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subscription } from 'rxjs';
import { BaseService } from './base.service';
import * as _ from 'lodash';
import { DispatchSearch } from '../DispatchSearch';
import { v_DispatchSearchBus } from '../models/v_DispatchSearchBus';
import { WidgetSearch } from '../models/WidgetSearch';
import { FileInfo } from '@progress/kendo-angular-upload';
import { v_DispatchAttachmentBus } from '../models/v_DispatchAttachmentBus';
import { DispatchAssignmentBus } from '../models/DispatchAssignmentBus';
import { CommonParam } from '../models/CommonParam';
import { CommonFunctions } from '../static/common-functions';
import { FeatureFlagService } from './feature-flag.service';
import { environment } from '@env/environment';
import { DispatchAiSummaryBus } from '../models/DispatchAiSummaryBus';

export class TestA {
    public userId: any;
    //public string locationId { get; set; }
    //public string openStatusesOnly { get; set; }
}

@Injectable()
export class DispatchesService extends BaseService  implements OnDestroy{
    private _featureFlagSet: any = {};
    private _featureSubscription: Subscription;

    constructor(_http: HttpClient,
        private _featureFlagService: FeatureFlagService) {
        super(_http);
        this.baseUrl = this.rootUrl + "Dispatch/";
        this._featureSubscription = this._featureFlagService.featureFlagSets.subscribe(data => {
            this._featureFlagSet = data;
        });
    }

    ngOnDestroy(): void {
        if (this._featureFlagSet['construction-job-attachments'] && this._featureSubscription) {
            this._featureSubscription.unsubscribe();
        }
    }

    getMapItemById(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetMapItemById/" + Id;

        return super.get(url_call);
    }
    getViewById(url: string, Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetViewById/" + Id;
        return super.get(url_call);
    }

    /**
     * This endpoint is used by the dispatch-image component. This is accessed external by users without a login
     *
     * @param {string} Id
     * @return {*}  {Observable<any>}
     * @memberof DispatchesService
     */
    getClientViewById(Id: string): Observable<any> {
        let url_call: string = environment.APIEndPointExternal + "Dispatch/GetClientViewById/" + Id;
        return this._http.get(url_call);
    }
    get(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "Get/" + Id;
        return super.get(url_call);
    }
    getDispatchForCheckValid(Id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchForCheckValid/" + Id;
        return super.get(url_call);
    }
    getByCustomer(url: string, Id: string, openStatusesOnly: boolean = false): Observable<any> {
        let url_call: string = this.baseUrl + "GetByCustomer/" + Id + "/" + openStatusesOnly;
        return this.get(url_call);
    }
    getByUserAndLocation(userId: string, locationId: string = '', openStatusesOnly: boolean = false): Observable<any> {
        let options = this.getOptionsUL(userId, locationId, "openstatusesonly", openStatusesOnly ? "true" : "false");
        let url_call: string = this.baseUrl + "GetByUserAndLocation"; ///" + userId + "/" + locationId + "/" + openStatusesOnly;
        return this._http.get(url_call, options); // { headers: headers }); //options ); //, { headers: headers });
    }
    getGridByUserAndLocation(userId: string, locationId: string = '', openStatusesOnly: boolean = false): Observable<any> {
        let options = this.getOptionsUL(userId, locationId, "openstatusesonly", openStatusesOnly ? "true" : "false");
        let url_call: string = this.baseUrl + "GetGridByUserAndLocation"; ///" + userId + "/" + locationId + "/" + openStatusesOnly;
        return this._http.get(url_call, options); // { headers: headers }); //options ); //, { headers: headers });
    }
    getStatusCountsByUserAndLocation(userId: string, locationId: string = '', openStatusesOnly: boolean = false): Observable<any> {
        let options = this.getOptionsUL(userId, locationId, "openstatusesonly", openStatusesOnly ? "true" : "false");
        let url_call: string = this.baseUrl + "GetStatusCountsByUserAndLocation" //"TestQ"; // "GetStatusCountsByUserAndLocation";

        return this._http.get(url_call, options); // data, options); //,data, options); //, { headers: headers }); //, { headers: reqHeader } ); //, { headers: headers });
    }

    getServiceLocationsByUserAndLocation(userId: string, locationId: string = ''): Observable<any> {
        let options = this.getOptionsUL(userId, locationId);
        let url_call: string = this.baseUrl + "GetServiceLocationsByUserAndLocation" //"TestQ"; // "GetStatusCountsByUserAndLocation";

        return this._http.get(url_call, options); // data, options); //,data, options); //, { headers: headers }); //, { headers: reqHeader } ); //, { headers: headers });
    }
    getStatusCountsByCustomer(url: string, customerId: string, openStatusesOnly: boolean = false): Observable<any> {
        let url_call: string = this.baseUrl + "GetStatusCountsByCustomer/" + customerId + "/" + openStatusesOnly;
        return this._http.get(url_call); //, { headers: headers });
    }

    /**
     * This endpoint is used by the dispatch-image component. This is accessed external by users without a login
     *
     * @param {string} dispatchId
     * @return {*}  {Observable<any>}
     * @memberof DispatchesService
     */
    getClientAttachments( dispatchId: string): Observable<any> {
        let url_call: string = environment.APIEndPointExternal + "Dispatch/GetClientAttachments/" + dispatchId ;
        return this._http.get(url_call); //, { headers: headers });
    }
    getServiceLocationsByCustomer(url: string, customerId: string): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = url + customerId;
        return this._http.get(url_call, { headers: headers }); //, { headers: headers });
    }

    /**
     * This endpoint is used by the dispatch-image component. This is accessed external by users without a login
     *
     * @param {string} Id
     * @return {*}
     * @memberof DispatchesService
     */
    getClientDocument(Id: string) {
        let url_call: string = environment.APIEndPointExternal + "Dispatch/GetClientDocument/" + Id;
        return this._http.get(url_call); //, { headers: headers });
    }
    getDocument(Id: string) {
        let url_call: string = this.baseUrl + "GetDocument/" + Id;
        return super.get(url_call); //, { headers: headers });
    }
    getDispatchSummary(id: string): Observable<DispatchAiSummaryBus> {
        if (id && CommonFunctions.hasGuidValue(id)) {
            let url_call: string = this.baseUrl + "GetDispatchAiSummary/" + id;
            return super.get(url_call);
        }
        return of(null);
    }
    GetAdditionalDispatchData(id: string): Observable<any> {
        if(id && CommonFunctions.hasGuidValue(id)) {
            let url_call: string = this.baseUrl + "GetAdditionalDispatchData/" + id
            return super.get(url_call);
        }
        return of(null);
    }
    getReferenceDataUpdateDate(): Observable<any> {
        let url_call: string = environment.APIEndPointRefData + "Dispatch/GetReferenceDataUpdateDate";
        return super.get(url_call);
    }
    GetReferenceData(companyId: string, forceServerRefresh: boolean = false): Observable<any> {
        let url_call: string;
        if (forceServerRefresh) {
            url_call = environment.APIEndPointRefData + "Dispatch/GetReferenceData/" + companyId + "?forceReload=true"
        } else {
            url_call= environment.APIEndPointRefData + "Dispatch/GetReferenceData/" + companyId
        }
        return super.get(url_call);
    }
    GetDispatchBySearch(search: DispatchSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsUL('', '', "search", s_search);
        let url_call: string = this.baseUrl + "GetDispatchBySearch";

        return this._http.get(url_call, options);

    }
    SearchHistory(search: DispatchSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        //let options = this.getOptionsUL('', '', "search", s_search);
        let url_call: string = this.rootUrl_v2 + "Search/dispatch/history";

        return super.post(url_call, s_search);

    }
    quickSearch(search: string): Observable<v_DispatchSearchBus[]> {
        if (search === undefined || search === null)
            return;
        let url_call: string = this.baseUrl + "QuickSearch/" + search;
        return super.get(url_call);
    }
    /*******************************************************
    DispatchScreen
    *******************************************************/
    GetDocs(id: string, includeSystemGenerated: boolean = true): Observable<any> {
        let featureFlag = this._featureFlagSet['construction-job-attachments'];
        if (featureFlag) {
            let url_call: string = this.baseUrl + "GetDocs/" + id + "/" + includeSystemGenerated;
            return super.get(url_call);
        } else {
            let url_call: string = this.baseUrl + "GetDocs/" + id;
            return super.get(url_call);
        }

    }
    GetImages(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetImages/" + id
        return super.get(url_call);
    }
    getNotesView(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetNotesView/" + id
        return super.get(url_call);
    }

    GetDispatchAssignments(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchAssignments/" + id
        return super.get(url_call);
    }
    getDispatchAssignmentNames(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchAssignmentNames/" + id
        return super.get(url_call);
    }
    GetDispatchLabor(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchLabor/" + id
        return super.get(url_call);
    }
    GetDispatchStatusHistory(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchStatusHistory/" + id
        return super.get(url_call);
    }
    GetDispatchEquipment(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchEquipment/" + id
        return super.get(url_call);
    }
    GetDispatchEquipmentServiced(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchEquipmentServiced/" + id
        return super.get(url_call);
    }
    GetDispatchParts(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchParts/" + id
        return super.get(url_call);
    }
    GetInventoryQVs(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInventoryQVs/" + id
        return super.get(url_call);
    }
    GetDispatchPartsRequested(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchPartsRequested/" + id
        return super.get(url_call);
    }
    GetDispatchPartsOrdered(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchPartsOrdered/" + id
        return super.get(url_call);
    }
    getDispatchPartsOrderedSubPO(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchPartsOrderedSubPO/" + id
        return super.get(url_call);
    }
    getDispatchPartsOrderedAll(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchPartsOrderedAll/" + id
        return super.get(url_call);
    }
    getDispatchCustParts(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchCustParts/" + id
        return super.get(url_call);
    }
    GetHistory(id: string, param: CommonParam = new CommonParam()): Observable<any> {
        let url_call: string = this.baseUrl + "GetHistory/" + id
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    GetQuotes(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetQuotes/" + id
        return super.get(url_call);
    }
    GetInvoices(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoices/" + id
        return super.get(url_call);
    }
    getStatusDetailByWidgetSearch(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetStatusDetailByWidgetSearch";
        return this._http.get(url_call, options);
    }
    getPendingChangeOrdersByWidgetSearch(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetPendingChangeOrdersByWidgetSearch";
        return this._http.get(url_call, options);
    }
    getCPForZuggitStatusDetailByWidgetSearch(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetCPForZuggitStatusDetailByWidgetSearch";
        return this._http.get(url_call, options);
    }
    getDispatchReviewDetailByWidgetSearch(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetStatusDetailByWidgetSearch";
        return this._http.get(url_call, options);
    }
    GetDispatchReviewDetail(search: WidgetSearch): Observable<any> {
        search.active = false;
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDispatchReviewDetail";
        return this._http.get(url_call, options);
    }
    getScheduledDispatches(): Observable<any> {
        let url_call: string = this.baseUrl + "GetScheduledDispatches/"
        return super.get(url_call);
    }
    getDispatchThirdPartyHistory(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchThirdPartyHistory/" + id
        return super.get(url_call);
    }
    GetDispatchRankOrders(): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchRankOrders"
        return super.get(url_call);
    }
    saveScheduledDispatches(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveScheduledDispatches";
        return this._http.put(url_call, model, { headers });
    }
    saveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAll";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatch(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAndReturn";
        return this._http.put(url_call, model, { headers });
    }
    saveNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "Note_Save";
        return this._http.put(url_call, model, { headers });
    }
    saveKudosAndOpportunityBus(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveKudosAndOpportunities";
        return this._http.put(url_call, model, { headers });
    }

    saveDispatchRefTracking(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchRefTracking";
        return this._http.put(url_call, model, { headers });
    }
    deleteDispatchRefTracking(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeleteDispatchRefTracking/";
        return super.delete(url_call, id);
    }

    savePartsRequest(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DispatchPartsRequest_Save";
        return this._http.put(url_call, model, { headers });
    }
    deletePartsRequest(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DispatchPartsRequest_Delete/";
        return super.delete(url_call, id);
    }
    deleteNote(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DispatchNote_Delete/";
        return super.delete(url_call, id);
    }
    saveCustParts(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DispatchCustParts_Save";
        return this._http.put(url_call, model, { headers });
    }
    deleteCustParts(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DispatchCustParts_Delete/";
        return super.delete(url_call, id);
    }
    getDQOIItem(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDQOIItem/" + id
        return super.get(url_call);
    }
    saveDispatchAssignment(model: DispatchAssignmentBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchAssignment";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchAssignments(model: DispatchAssignmentBus[]): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchAssignments";
        return this._http.put(url_call, model, { headers });
    }
    getErrors(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetErrors/" + id;
        return super.get(url_call);
    }
    saveError(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveError";
        return this._http.put(url_call, model, { headers });
    }
    deleteError(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteError/" + id;
        return this._http.delete(url_call, { headers });
    }
    saveLabor(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveLabor";
        return this._http.put(url_call, model, { headers });
    }
    deleteLabor(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteLabor/" + id;
        return this._http.delete(url_call, { headers });
    }
    saveDispatchEquipment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchEquipment";
        return this._http.put(url_call, model, { headers });
    }
    deleteDispatchEquipment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteDispatchEquipment/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteDispatchPart(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteDispatchPart/" + id;
        return this._http.delete(url_call, { headers });
    }
    saveAttachment(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAttachment";
        return this._http.put(url_call, model, { headers });
    }
    uploadAttachment(files: FileInfo[], data: v_DispatchAttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "UploadAttachment";
        let dataStr: string = JSON.stringify(data);
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        const formData = new FormData();
        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }
        formData.append("attachmentData", dataStr);
        return this._http.put(url, formData);
    }
    deleteAttachment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteAttachment/" + id;
        return this._http.delete(url_call, { headers });
    }
    getVendorCredits(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetVendorCredits/" + id;
        return super.get(url_call);
    }
    getAssets(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAssets/" + id;
        return super.get(url_call);
    }
    getDispatchTrucks(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchTrucks/" + id;
        return super.get(url_call);
    }
    getAssignTechInfo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAssignTechInfo/" + id;
        return super.get(url_call);
    }
    getTech(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetTech/" + id;
        return super.get(url_call);
    }
    getAssignableTechs(param: any): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetAssignableTechs";
        return this._http.get(url_call, options);
    }
    getNearestVehicles(param: any): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetNearestVehicles";
        return this._http.get(url_call, options);
    }
    mergeDispatches(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "MergeDispatches";
        return this._http.put(url_call, model, { headers });
    }
    deleteDispatch(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteDispatch/" + id;
        return this._http.delete(url_call, { headers });
    }
    deleteDispatchAssignment(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteDispatchAssignment/" + id;
        return this._http.delete(url_call, { headers });
    }
    duplicateDispatch(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DuplicateDispatch/" + id;
        return super.get(url_call);
    }
    //Returns BaseMessageInfo with Email as PrimaryReturn
    getWalMartEmail(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetWalMartEmail/" + id;
        return super.get(url_call);
    }
    getEmailDefaultsForDispatch(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetEmailDefaultsForDispatch/" + id;
        return super.get(url_call);
    }

    canCreate(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CanCreate";
        return this._http.put(url_call, model, { headers });
    }
    personContactInfo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "PersonContactInfo/" + id;
        return super.get(url_call);
    }
    testParam(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "TestParam";
        return this._http.put(url_call, model, { headers });
    }
    testParam2(model: any): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "TestParam2";
        return this._http.get(url_call, options);
    }
    testParam3(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "TestParam3";
        return this._http.put(url_call, model, { headers });
    }
    print(id: any): Observable<any> {
        let url_call: string = this.baseUrlCPConn + "PrintDispatch/" + id;
        return super.get(url_call);
    }
    validate(model: any, code: string) {
        let headers = this.getHeaders();
        let sModel = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "model", sModel);
        let url_call: string = this.baseUrl + "Validate/" + code;
        return this._http.get(url_call, options);
    }
    validateDispatchLaborOverLap(model: any): Observable<any> {
        let headers = this.getHeaders();
        let sModel = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "model", sModel);
        let url_call: string = this.baseUrl + "ValidateDispatchLaborOverLap";
        return this._http.put(url_call, model, { headers });
    }
    checkForChange(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CheckForChange";
        return this._http.put(url_call, model, { headers });
    }

    attachmentsDownloadAllStream(id: any) {
        let url_call: string = this.baseUrl + "AttachmentsDownloadAllStream/" + id;
        //return super.get(url_call);
        return super.getWithResponseType(url_call,'blob');
    }
    attachmentsDownloadAll(id: any) {
        let url_call: string = this.baseUrl + "AttachmentsDownloadAll/" + id;
        return super.get(url_call);
    }

    checkDispatchStatusChange(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "CheckDispatchStatusChange";
        return this._http.get(url_call, options);
    }
    changeDispatchStatus(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "ChangeDispatchStatus";
        return this._http.get(url_call, options);
    }
    getAssignableTechsForFldSvcSupQV(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetAssignableTechsForFldSvcSupQV";
        return this._http.get(url_call, options);
    }
    getDispatchQV(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchQV/" + id;
        return super.get(url_call);
    }
    getAdditionalDispatchDataQV(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetAdditionalDispatchDataQV/" + id
        return super.get(url_call);
    }
    saveDispatchItemQV(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchItemQV";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchItemsQV(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchItemsQV";
        return this._http.put(url_call, model, { headers });
    }
    getDispatchNotes(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchNotes/" + id;
        return super.get(url_call);
    }
    getDispatchLaborQV(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchLaborQV/" + id;
        return super.get(url_call);
    }
    saveDispatchAttachmentApproved(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "SaveDispatchAttachmentApproved/" + id;
        return super.get(url_call);
    }
    saveDispatchLaborApprovalQV(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchLaborApprovalQV";
        return this._http.put(url_call, model, { headers });
    }
    saveInventoryQV(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveInventoryQV";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchParts(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchParts";
        return this._http.put(url_call, model, { headers });
    }
    saveDispatchStatus(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchStatus";
        return this._http.put(url_call, model, { headers });
    }
    getDispatchKudos(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetDispatchKudos/" + id;
        return super.get(url_call);
    }
    closeDispatchAssignments(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "CloseDispatchAssignments/" + id;
        return super.get(url_call);
    }
    saveDispatchKudos(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDispatchKudos";
        return this._http.put(url_call, model, { headers });
    }
    deleteDispatchKudos(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteDispatchKudos/" + id;
        return this._http.delete(url_call, { headers });
    }
    getKudosAndOpportunities(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetKudosAndOpportunities/" + id;
        return super.get(url_call);
    }
    setCallbacks(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SetCallbacks";
        return this._http.put(url_call, model, { headers });
    }
    getPrimaryNumber(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetPrimaryNumber/" + id;
        return super.get(url_call);
    }
    getTestData(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetTestData";
        return this._http.get(url_call, options);
    }
    getCallbackInfo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCallbackInfo/" + id
        return super.get(url_call);
    }
    saveCallbackTab(id: any, param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrl + "SaveCallbackTab/" + id;
        let headers = this.getHeaders();
        return this._http.put(url_call, param, { headers });
    }
    updateOpenDispatchCostsAll(): Observable<any> {
        let url_call: string = this.baseUrl + "UpdateOpenDispatchCostsAll"
        return super.get(url_call);
    }
    thirdPartyAutoCreate(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "ThirdPartyAutoCreate";
        return this._http.put(url_call, model, { headers });
    }
    createSalesOrderFromDispatch(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "CreateSalesOrderFromDispatch/" + id
        return super.get(url_call);
    }
}
